import { ERROR_403, ERROR_404, ERROR_500 } from '@utils/api/constants';

export const getDomainOrigin = () => {
    try {
        if (window !== undefined) {
            if (window.location.hostname === 'localhost') {
                return 'http://localhost:9003';
            }
            if (
                process.env.NEXT_PUBLIC_ENVIRONMENT === 'life-prod' ||
                window.location.pathname.includes('life/embedded')
            ) {
                return `${window.location.origin}/life/embedded`;
            }
            return window.location.origin;
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'life-prod') {
            return 'https://www.acko.com/life/embedded';
        }
        return 'https://www.acko.com';
    } catch (e) {
        console.error('domain error ', e);
        return 'https://www.acko.com';
    }
};

export const getEiFrontlineDomainOrigin = () => {
    try {
        if (window !== undefined) {
            if (window.location.hostname === 'localhost') {
                return 'http://localhost:9003';
            }
            return window.location.origin;
        }
        return 'https://www.acko.com';
    } catch (e) {
        console.error('domain error ', e);
        return 'https://www.acko.com';
    }
};

export const getGiDomainOrigin = () => {
    if (isLocalServer()) {
        return 'http://localhost:9003';
    }
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'tronix') {
        return 'https://tronix.acko.com';
    }
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'master') {
        return 'https://www.ackodev.com';
    }
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'embedded-dev') {
        return 'https://dev-embedded.ackodev.com';
    }
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'embedded-qa') {
        return 'https://qa-embedded.ackodev.com';
    }
    return 'https://www.acko.com';
};

export const getServerHostDomain = (host?: string) => {
    try {
        if (host?.includes('localhost')) {
            return 'http://localhost:9003';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'tronix') {
            return 'https://tronix.acko.com';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'master') {
            return 'https://www.ackodev.com';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'embedded-dev') {
            return 'https://dev-embedded.ackodev.com';
        }
        if (
            process.env.NEXT_PUBLIC_ENVIRONMENT === 'embedded-qa' ||
            host?.includes('qa-embedded')
        ) {
            return 'https://qa-embedded.ackodev.com';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'life-prod') {
            return 'https://www.acko.com/life/embedded';
        }
        return 'https://www.acko.com';
    } catch {
        return 'https://www.acko.com';
    }
};

export function getHeaders() {
    return {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    };
}

export function getErrorMessage(
    responseCode: number,
    setErrorMessage: Function
) {
    switch (responseCode) {
        case 403:
            setErrorMessage(ERROR_403);
            break;
        case 404:
            setErrorMessage(ERROR_404);
            break;
        default:
            setErrorMessage(ERROR_500);
    }
}

export function isLocalServer() {
    if (typeof window !== 'undefined') {
        return window?.location?.origin?.includes('localhost');
    }
    return false;
}
